export const BASE_URL = 'https://api.jennifer-academy.com';
export const LOCAL_BASE_URL = 'http://localhost:4040';
export const FILE_BASE_URL = 'https://file.jennifer-academy.com';
